import { render, staticRenderFns } from "./fonts-titles.vue?vue&type=template&id=2968acdb"
import script from "./fonts-titles.vue?vue&type=script&lang=js"
export * from "./fonts-titles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports